export default "__VITE_ASSET__Dj4_Ppzj__"